import React from 'react'
import PropTypes, { object } from 'prop-types'
import classnames from 'classnames'

import MediaDropzone from './elements/MediaDropzone'
import MediaList from './elements/MediaList/MediaList.component'

import { actions } from './media'
import PortalModal from 'components/Shared/PortalModal'

import { MediaExpandedModal } from './elements/MediaExpandedModal'
import { useMediaUploadService } from './MediaUpload.service'

const MediaUpload = ({
  initialMedia,
  onChange,
  readonly,
  canAdd,
  canRemove,
  canReplace,
  maxItems = Number.MAX_VALUE,
  isCampaignRunning,
  hasMediaPlacementError,
}) => {

  const { 
    media, 
    canAddInternal, 
    reachedMaxLimit, 
    isMobileSize, 
    expandedImage, 
    isFirstItem,
    isLastItem,
    ref, 
    state, 
    dispatch, 
    onNext, 
    onBack, 
    removeFile, 
    removeGroup, 
    handleAddFileToGroup, 
    handleReplaceFileInGroup, 
    getRootProps, 
    getInputProps, 
    open, 
    setExpandedImage 
  } = useMediaUploadService({ initialMedia, onChange, canAdd, canReplace, maxItems })
  
  const mediaUploadsClasses = classnames({
    'media-uploads': true,
    'media-uploads-empty': !media.length,
    'mobile-view': isMobileSize,
    'justify-content-between': media.length,
    'justify-content-center': !media.length,
    readonly: readonly,
  })

  return (
    <div>

      <div ref={ref} className={mediaUploadsClasses}>
        {!readonly && (
          <MediaDropzone
            media={media}
            getRootProps={getRootProps}
            getInputProps={getInputProps}
            isMobileSize={isMobileSize}
            canAddInternal={canAddInternal}
            isCampaignRunning={isCampaignRunning}
          />
        )}

        <MediaList
          onRemove={(fileId) => removeFile(fileId)}
          onRemoveGroup={(groupId) => removeGroup(groupId)}
          media={media}
          fileToReplace={state.fileToReplace}
          readonly={readonly}
          canAdd={canAdd}
          canAddInternal={canAddInternal}
          reachedMaxLimit={reachedMaxLimit}
          canRemove={canRemove}
          canReplace={canReplace}
          onRetry={(file) => dispatch({ type: actions.retryUploadAsync, payload: file })}
          onReplaceStarted={(index) => {
            dispatch({ type: actions.startReplace, payload: index })
            open()
          }}
          isMobileSize={isMobileSize}
          setExpandedImage={setExpandedImage}
          onAddFileToGroup={handleAddFileToGroup}
          onReplaceFileInGroup={handleReplaceFileInGroup}
          onValidationError={(errorMessages) => {
            onChange(media, null, false, errorMessages, false, false)
          }}
          hasMediaPlacementError={hasMediaPlacementError}
        />
      </div>
      
      {!!state.error && <p className="warning-red mt-2 text-left">{state.error}</p>}

      {expandedImage && (
        <PortalModal
          isOpen={!!expandedImage}
          className="full-height"
          onClickOutside={() => setExpandedImage(null)}
          title='Media Preview'
        >
          <MediaExpandedModal
            expandedImage={expandedImage}
            setExpandedImage={setExpandedImage}
            onBack={onBack}
            onNext={onNext}
            isFirstItem={isFirstItem}
            isLastItem={isLastItem}
          />
        </PortalModal>
      )}
    </div>
  )
}

MediaUpload.propTypes = {
  initialMedia: PropTypes.arrayOf(object),
  onChange: PropTypes.func.isRequired,
  maxItems: PropTypes.number,
  readonly: PropTypes.bool,
  canAdd: PropTypes.bool,
  canRemove: PropTypes.bool,
  canReplace: PropTypes.bool,
  validationError: PropTypes.bool,
  isCampaignRunning: PropTypes.bool,
  hasMediaPlacementError: PropTypes.bool,
}

export default MediaUpload
